<template>
    <div class="material-item">
        <div class="material-screenshot">
            <svg-icon
            v-if="data.type === 'audio'"
            href="#material-type-audio"
            width="32"
            height="32"
            class="matrial-card-icon"
            >
            </svg-icon>
            <el-image
                v-else-if="data.type === 'motion' || (data.type === 'media' && data.metadata.playType === 'special')"
                :src="previewImg"
                fit="cover"
                lazy
                :scroll-container="scrollContainer"
                >
                    <el-image slot="placeholder" :src="thumbImg" style="opacity: .5;"></el-image>
                </el-image>
            <el-image v-else :src="thumbImg" fit="contain"></el-image>
        </div>
        <div class="material-name">
            {{getNameI18n(data.metadata)}}
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex';
export default {
    name: "material-item",
    props: {
        data: Object,
        scrollContainer: Object // 圖片懶加載綁定的滾動元素
    },
    data(){
        return {
            previewMotionTimer: null
        }
    },
    computed: {
    	...mapState({
            $baseUrl: "env$"
        }),
        thumbImg(){
            if(this.data.type === 'motion'){
                return `${this.$baseUrl}static/images/material_lib_motion_screenshot.png`
            } else {
                return this.util$.formatUrlWithToken$(this.data.screenshot)
            }
        },
        previewImg(){
            if(this.data.type === 'motion'){
                return this.util$.formatUrlWithToken$(this.data.screenshot)
            }
            if(this.data.type === 'media' && this.data.metadata.playType === 'special'){
                return this.util$.formatUrlWithToken$(this.data.screenshot2)
            }
            return ''
        }
    },
    methods: {
        getNameI18n({title, i18n}){
            return this.util$.getI18nLabel$(i18n, "langCode", "name") || title;
        }
    }
}
</script>
<style lang="scss">
.material-item{
    width: 100%;
    height: 100%;
    .material-screenshot, .material-motion-icon{
        display: block;
        width: 172px;
        height: 98px;
        font-size: 0;
        line-height: 96px;
        text-align: center;
        border: none;;
        .svg-icon{
            fill: #a8a8ac;
        }
    }
    .material-screenshot{
        overflow: hidden;
        .el-image{
            width: 100%;
            height: 100%;
        }
    }
    .material-motion-icon:hover{
        background: #ddd;
    }
    .material-name{
        width: 100%;
        height: 32px;
        padding: 0 6px;
        line-height: 32px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        color: #323333;
        background: #ffffff;
        font-size: 14px;
        text-align: center;
    }
}
.el-tooltip__popper.material-motion-preview{
    width: 300px;
    height: 200px;
    padding: 6px;
    border: none;
    .preview-content{
        width: 100%;
        height: 100%;
        .material-screenshot{
            width: 100%;
            height: 100%;
            text-align: center;
            line-height: 200px;
        }
    }
    .popper__arrow{
        top: -50px;
    }
    &.el-tooltip__popper[x-placement^="right"] .popper__arrow {
        border-right-color: #272727;
    }
    &.el-tooltip__popper[x-placement^="right"] .popper__arrow:after {
        border-right-color: #272727;
    }
}
</style>